<template>
  <div>
    <BlocoFiltroPesquisa
      titulo="Profissional"
      nome-do-form="ProfissionalAgendamentoForm"
      @pesquisar="pesquisar"
    >
      <template #form>
        <div class="row">
          <div class="form-group col-xs-12 col-sm-10 col-md-8 col-lg-8">
            <CampoNome :valor="profissional.nome" somente-leitura="true" />
          </div>
          <div class="form-group col-xs-12 col-sm-2 col-md-4 col-lg-4">
            <CampoGenerico
              :valor="profissional.numeroConselho"
              label="Número conselho"
              somente-leitura="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
            <SelecionarUnidade
              :valor="filtro.unidade"
              @atualizar="filtro.unidade = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
            <SelecionarEspecialidade
              :valor="filtro.especialidade"
              @atualizar="filtro.especialidade = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-8 col-md-4 col-lg-2">
            <SelecionarData
              id="dataInicio"
              label="Data Início"
              :valor="filtro.dataInicio"
              @atualizar="filtro.dataInicio = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-8 col-md-4 col-lg-2">
            <SelecionarData
              id="dataFim"
              label="Data Fim"
              :valor="filtro.dataFim"
              @atualizar="filtro.dataFim = $event"
            />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <BlocoPaginadorPesquisa
      :total="total"
      :modo-resultado="modoResultado"
      @paginaAlterada="paginaAlterada"
      @modoAlterado="modoAlterado"
    />
    <BlocoResultadoPesquisa :total="total" :modo-resultado="modoResultado">
      <template #tabela
        ><ProfissionalAgendamentosTabela
          :agendamentos="agendamentos"
          @atualizar="atualizar"
      /></template>
      <template #fichas>
        <div
          v-for="agendamento in agendamentos"
          :key="agendamento._id"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
        >
          <ProfissionalAgendamentosFicha
            :agendamento="agendamento"
            @atualizar="atualizar"
          />
        </div>
      </template>
    </BlocoResultadoPesquisa>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BlocoPaginadorPesquisa from '@/componentes/formulario/BlocoPaginadorPesquisa'
import BlocoResultadoPesquisa from '@/componentes/formulario/BlocoResultadoPesquisa'
import CampoGenerico from '@/componentes/formulario/CampoGenerico'
import CampoNome from '@/componentes/formulario/CampoNome'
import SelecionarData from '@/componentes/formulario/SelecionarData'
import SelecionarEspecialidade from '@/componentes/formulario/SelecionarEspecialidade'
import SelecionarUnidade from '@/componentes/formulario/SelecionarUnidade'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import ProfissionalServico from '@/servicos/ProfissionalServico'

import ProfissionalAgendamentosFicha from './ProfissionalAgendamentosFicha'
import ProfissionalAgendamentosTabela from './ProfissionalAgendamentosTabela'

const menuAtual = {
  descricao: 'Agendamentos do profissional',
  descricaoNovo: 'Novo(a)',
  breadcrumb: ['Atendimento', 'Profissionais', 'Agendamentos do profissional'],
}

export default {
  components: {
    ProfissionalAgendamentosFicha,
    ProfissionalAgendamentosTabela,
    BlocoFiltroPesquisa,
    CampoNome,
    CampoGenerico,
    SelecionarUnidade,
    SelecionarEspecialidade,
    SelecionarData,
    BlocoResultadoPesquisa,
    BlocoPaginadorPesquisa,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const agendamentos = ref([])
    const profissional = ref({
      numeroConselho: '',
      nome: '',
    })
    const filtro = ref({
      profissionalId: '',
      unidade: '',
      especialidade: '',
      dataInicio: '',
      dataFim: '',
    })
    const servico = new ProfissionalServico()
    const nomeResultado = 'agendamentos'
    const pesquisa = usePesquisa({
      filtro,
      resultado: agendamentos,
      servico,
      nomeResultado,
      recuperarTotal: (filtroAtual) =>
        servico.recuperarAgendamentosTotal(filtroAtual),
      recuperarTodos: (filtroAtual) =>
        servico.recuperarAgendamentos(filtroAtual),
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(menuAtual)
    return {
      agendamentos,
      profissional,
      servico,
      filtro,
      ...pesquisa,
    }
  },

  created() {
    this.recuperarProfissional()
  },
  methods: {
    recuperarTotal() {
      return this.servico.recuperarAgendamentosTotal(this.filtro)
    },
    recuperarTodos() {
      return this.servico.recuperarAgendamentos(this.filtro)
    },
    atualizar() {
      this.pesquisar(this.filtro.skip)
    },
    recuperarProfissional() {
      if (this.$route.params.id) {
        const profissionalId = this.$route.params.id
        this.filtro.profissionalId = profissionalId
        this.servico.recuperar(profissionalId).then((result) => {
          const profissional = {
            numeroConselho: result.profissional.numeroConselho,
            nome: result.profissional.nome,
          }
          this.profissional = profissional
        })
      }
    },
  },
}
</script>

<style>
.data_hora {
  padding: 0;
  margin: 0;
  font-size: 1.1em;
}

.icone_calendario {
  font-size: 2.2em;
}

.status_agendamento {
  font-size: 1.1em;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
